/**
 * Client-side preview evaluation. Mirrors the backend audience logic so the
 * admin preview can filter rows without a round-trip.
 */

/**
 * Is a top-section dashboard row visible for the preview's selected groups?
 * @param {Object} row - dashboard row with `audienceGroups`
 * @param {number[]|null} selectedGroupIds - null = All Content (show everything)
 * @returns {boolean}
 */
function isRowVisibleForPreview(row, selectedGroupIds) {
  if (selectedGroupIds === null) return true;
  if (!row.audienceGroups || row.audienceGroups.length === 0) return true;
  const rowGroupIds = row.audienceGroups.map((g) => g.groupId);
  if (rowGroupIds.includes(0)) return true;
  return selectedGroupIds.some((id) => rowGroupIds.includes(id));
}

/**
 * Is a program-section row visible for the preview's selected groups?
 * Program audience is based on `Program.ProgramGroups`.
 * @param {Object} programRow - program row with `Program.ProgramGroups`
 * @param {number[]|null} selectedGroupIds - null = All Content (show everything)
 * @returns {boolean}
 */
function isProgramVisibleForPreview(programRow, selectedGroupIds) {
  if (selectedGroupIds === null) return true;
  const programGroups = ((programRow.Program && programRow.Program.ProgramGroups) || []).filter(
    (g) => g && g.status !== "Deleted"
  );
  if (programGroups.length === 0) return true;
  const programGroupIds = programGroups.map((g) => g.groupId);
  if (programGroupIds.includes(0)) return true;
  return selectedGroupIds.some((id) => programGroupIds.includes(id));
}

export { isRowVisibleForPreview, isProgramVisibleForPreview };
